export const mismatch = {
    "yes": ["A4297", "A4299", "A4314", "A4317", "A4318", "A4319",
        "A6682", "A6702", "A6704", "A6706", "A6708", "A6731", "A6729",
        "A6727", "A6725", "A6723", "A6725", "A6727", "A6729", "A6731", "A6713",
        "A6715", "A6717", "A6719", "A6721", "A6723", "A6725", "A6727", "A6729",
        "A6731", "A6663", "A6657", "A6659", "A6667", "A6665", "A6655", "A6661",
        "A4304", "A4352", "A4353", "A4354", "A4355"
    ],
    "no": [],
    "value": {
        "A4310": ["6663"],
        "A4307": ["6657"],
        "A4308": ["6659"],
        "A4312": ["6667"],
        "A4311": ["6665"],
        "A4306": ["6655"],
        "A4309": ["6661"],
        "A4350": ["6741"],
        "A4351": ["6746"],
        "A4338": ["6713"],
        "A4339": ["6715"],
        "A4340": ["6717"],
        "A4341": ["6719"],
        "A4342": ["6721"],
        "A4343": ["6723"],
        "A4322": ["6689"],
        "A4332": ["6702"],
        "A4333": ["6704"],
        "A4334": ["6706"],
        "A4335": ["6708"],
        "A4344": ["6725"],
        "A4345": ["6727"],
        "A4346": ["6729"],
        "A4347": ["6731"],
        "A4326": ["6694", "6698", "6700"],
        "physical": "fail"
    }
};

export const unqualified = {
    "yes": ["A4315"],
    "no": ["A4298", "A4303"],
    "value": {
        "province_current": ["X"]
    }
};

